var path = 'shared/kbLink/kbLink.tpl.html';
var html = "<span ng-if=\"article\" class=\"sbsf-kb-link\">\n  <a href=\"{{ article }}\" target=\"_blank\">\n    {{ \"QUESTION_MARK\" | i18n }}\n  </a>\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;